import { createAction } from '@poa/state';

// fetching
export const fetchDashboard = createAction('dashboard/fetchDashboard', (fetchType) => ({ fetchType }));
export const fetchNewDashboard = createAction('dashboard/fetchNewDashboard', ({calendarPageMode, calendarDateMode}) => ({calendarPageMode, calendarDateMode}));
export const fetchSuccess = createAction('dashboard/fetchSuccess', () => ({}));


export const fetchDataSuccess = createAction('dashboard/fetchDataSuccess', (data , reportsPrevious) => ({data , reportsPrevious}));
export const fetchProfitSuccess = createAction('dashboard/fetchProfitSuccess', (profitData, profitReportPrevious) => ({profitData, profitReportPrevious}));
export const fetchCalendarSuccess = createAction('dashboard/fetchCalendarSuccess', calendarData => ({calendarData}));
export const fetchUsersSuccess = createAction('dashboard/fetchUsersSuccess', dashboardUsers => ({dashboardUsers}));
export const fetchClientsSuccess = createAction('dashboard/fetchClientsSuccess', dashboardClients => ({dashboardClients}));


export const fetchExpandableSuccess = createAction('dashboard/fetchExpandableSuccess', data => ({ data }));
export const fetchFailed = createAction('dashboard/fetchFailed', () => ({}));
export const setDates = createAction('dashboard/setDates', ({startDate, endDate}) => ({ startDate, endDate }));
